export const SET_PERMISSIONS = "SET_PERMISSIONS";

export function setPermissions(payload: any){
    return {type: SET_PERMISSIONS, payload};
};